import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveResourceFromResourceGroupNotificationState =
  createStateReducer(initialState, {
    [events.removeResourceFromResourceGroupSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromResourceGroup",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeResourceFromResourceGroupFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromResourceGroup",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  });

export { reduceRemoveResourceFromResourceGroupNotificationState };
